import React, { Dispatch, SetStateAction } from "react";
import CooperativeFilters from "./CooperativeFilters";
import CooperativeTable from "./CooperativeTable";
import useMobile from "../../hooks/useMobile";
import { useNavigate } from "react-router-dom";
import { ICooperative } from "../../exports/interfaces";
import { UserRoundPlus } from "lucide-react";

const CooperativeList = ({
  cooperative,
  setCooperative,
}: {
  cooperative: ICooperative[];
  setCooperative: Dispatch<SetStateAction<ICooperative[]>>;
}) => {
  const isMobile = useMobile();
  const navigate = useNavigate();

  return (
    <>
      <div className="d-flex justify-content-between align-items-center mb-3">
        <div>
          <h3>Cooperatives List</h3>
          <small>25 REGISTERED, 05 UNREGISTERED</small>
        </div>

        <button
          className="btn px-3 btn-badge"
          onClick={() => navigate("/register-new")}
        >
           <i className={`${!isMobile ? "me-2" : ""}`}>
            <UserRoundPlus size={20}/>
          </i>
          {!isMobile && "Register Here"}
        </button>
      </div>
      <CooperativeFilters />
      <CooperativeTable cooperative={cooperative} setCooperative={setCooperative}/>
    </>
  );
};

export default CooperativeList;
